var _style, _symbol, _g, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidationWarningOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "validation-warning-outline_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 40 40",
    xmlSpace: "preserve",
    className: "validation-warning-outline_svg__sprite validation-warning-outline_svg__replaced-svg"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".validation-warning-outline_svg__st0{fill:none;stroke:#575757;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round}")), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "validation-warning-outline_svg__icon_error",
    viewBox: "-20 -20 40 40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "validation-warning-outline_svg__st0",
    d: "M-1.7-11l-12 20c-.6.9-.3 2.2.7 2.7.3.2.7.3 1 .3h23.9c1.1 0 2-.9 2-2 0-.4-.1-.7-.3-1L1.7-11c-.5-1-1.8-1.3-2.7-.7-.3.1-.5.4-.7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-20-20h40v40h-40z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "validation-warning-outline_svg__UI"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#validation-warning-outline_svg__icon_error",
    width: 40,
    height: 40,
    id: "validation-warning-outline_svg__XMLID_1_",
    x: -20,
    y: -20,
    transform: "translate(20 20)",
    overflow: "visible"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "validation-warning-outline_svg__st0",
    d: "M20 16.5v7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "validation-warning-outline_svg__st0",
    cx: 20,
    cy: 27,
    r: 0.5
  })));
}
export default SvgValidationWarningOutline;